import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ripple from 'vuetify/lib/directives/ripple';
import pt from 'vuetify/src/locale/pt';

Vue.use(Vuetify, {directives: {ripple}})

const theme = {
    primary: '#008597',
    secondary: '#008597',
    accent: '#008597',
    info: '#008597',
    success: '#008597',
    warning: '#FB8C00',
    error: '#FF5252',
    clean: '#6d6e70'
}

export default new Vuetify({
    breakpoint: {mobileBreakpoint: 960},
    lang: {
        locales: {pt},
        current: 'pt',
    },
    icons: {
        values: {expand: 'mdi-menu-down'},
    },
    theme: {
        dark: true,
        themes: {
            dark: theme,
            light: theme,
        },
    },
})
